import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { SubscriptionService } from 'src/app/pages/subscription/services/subscription.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { TokenPack } from 'src/app/pages/shared/token-credit-modal/model/token-credit.model';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-ai-token-restock',
    templateUrl: './ai-token-restock.component.html',
    styleUrls: ['./ai-token-restock.component.scss'],
    standalone: false
})
export class AiTokenRestockComponent implements OnInit {
  userId: number | string | any;
  tokenPacks: TokenPack[] = [];
  isLoading: boolean = false;
  currentUserSubscription: Subscription;

  constructor(public activeModal: NgbActiveModal,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private currentUserService: CurrentUserService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.currentUserSubscription = this.currentUserService.currentUser.subscribe((res) => {
      if (res && res.id) {
        this.userId = res.id;
        this.getProducts();
      }
    
          this.cdr.detectChanges();});
  }

  getProducts() {
    this.isLoading = true;
    this.subscriptionService.getStripeProducts().subscribe({
      next: (res: { token_packs: TokenPack[] }) => {
        this.tokenPacks = res.token_packs;
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
      
          this.cdr.detectChanges();}
    });
  }

  buyProduct(tokenPackId: number) {
    this.subscriptionService.createTokenPackCheckoutSession(this.userId, tokenPackId, 'flow=char').subscribe((res) => {
      if (res && res.checkout_url) {
        window.open(res.checkout_url, '_blank');
        this.activeModal.close();
      }
    
          this.cdr.detectChanges();});
  }

  closeModal() {
    this.activeModal.close();
  }

  purchaseTokens() {
    // TODO: Implement actual purchase navigation
    // window.open('https://billing.stripe.com/...', '_blank');
    this.activeModal.close('purchase');
    this.router.navigate(['/subscription']);
  }
}
